export const AV_ORIGIN_COLUMN_LIST = [
  `city`,
  `district`,
  `postalCode`,
  `addressLine`,
  `addressExtension`,
  `country`,
  `countryCode`
];

export const AV_RESULT_COLUMN_LIST = [
  `city`,
  `district`,
  `postalCode`,
  `street`,
  `houseNumber`,
  `addressLine`,
  `addressExtension`,
  `country`,
  `countryCode`
];
